export default __webpack_public_path__ + "_/videos/lootbox/video-default-ccf2f66cf0aacafcec0b6b93f7118c5cce2a21a3835cb8368907488a36621227.ogv";